export const PRIMARY_COLOR = '#f49b1a';
